import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { Tooltip } from '@inplayer-org/inplayer-ui';

const StyledTooltip = styled(Tooltip)<{ width?: string }>`
  width: ${({ width }) => width || '20%'};
  button {
    width: 100%;
  }
`;

interface Props {
  content?: string;
  width?: string;
  children: ReactNode;
}

const ButtonTooltip = ({ content, width, children }: Props) => {
  if (!content) return <>{children}</>;
  return (
    <StyledTooltip content={content} width={width}>
      {children}
    </StyledTooltip>
  );
};

export default ButtonTooltip;
